export const STUDIO_CUSTOMER_COLOR = "#2DD4BF";
export const UNKNOWN_CUSTOMER_COLOR = "#94A3B8";

export function resolveCustomerTag(customer = {}, artists = [], tags = {}) {
  if (customer.customer_tag) return customer.customer_tag;
  if (customer.id && tags[customer.id]) return tags[customer.id];
  if (customer.ownership_type === "studio") return {kind:"studio",color:STUDIO_CUSTOMER_COLOR};
  if (customer.ownership_type === "artist") {
    const ref=customer.referring_artist_id;
    const artist=artists.find(a=>a.id===ref) || artists.find(a=>a.user_id && [String(a.user_id),`user:${a.user_id}`].includes(ref));
    if (artist) return {kind:"artist",color:artist.color?.toUpperCase() || "#111827",owner_id:artist.id,owner_name:artist.name};
  }
  return {kind:"unknown",color:UNKNOWN_CUSTOMER_COLOR};
}

export function tagTextColor(color) {
  const hex=(color || UNKNOWN_CUSTOMER_COLOR).replace('#','');
  const values=[0,2,4].map(i=>parseInt(hex.slice(i,i+2),16)/255).map(v=>v<=.04045?v/12.92:Math.pow((v+.055)/1.055,2.4));
  return values[0]*.2126+values[1]*.7152+values[2]*.0722>.179?'#111827':'#FFFFFF';
}


// Resolve assignment independently from the customer's original association.
export function resolveArtist(reference, artists = []) {
  return artists.find(a => a.id === reference) || artists.find(a => a.user_id && [String(a.user_id), `user:${a.user_id}`].includes(reference));
}
export function appointmentIdentity(appointment, customer = {}, artists = [], tags = {}) {
  const origin = resolveCustomerTag({...customer, id: appointment.customer_id}, artists, tags);
  const assigned = resolveArtist(appointment.artist_id, artists);
  const color = /^#[0-9a-f]{6}$/i.test(assigned?.color || '') ? assigned.color : '#111827';
  const sameOwner = origin.kind === 'artist' && assigned && origin.owner_id === assigned.id;
  return {color, assigned, origin, showOrigin: !sameOwner && origin.kind !== 'unknown'};
}
